import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { ChangePasswordFormType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { changePassword } from 'services/api/auth'
import { Response } from 'utils/fetchApi'

const WRONG_PASSWORD_ERROR_CODE = 9
const submitChangePassword = function* () {
  const body: ChangePasswordFormType = yield select(selectors.changePassword.getValues)

  const data: Response<void> = yield call(changePassword, body)

  if (!data.ok) {
    yield put(actions.form.change(formName.CHANGE_PASSWORD, 'loading', false))

    if (data.error.code === WRONG_PASSWORD_ERROR_CODE) {
      yield call(notifyError, data.error.cause, 'KO_CHANGE_PASSWORD')
      return
    }
    return
  }
  yield put(
    actions.analytics.trackEvent({
      key: 'Account Password Changed',
      properties: {
        account_type: 'CUSTODIAL'
      }
    })
  )

  yield call(notifySuccess, 'OK_CHANGE_PASSWORD')
  yield put(actions.app.hideModal('CHANGE_PASSWORD'))
}

export default function* changePasswordForm() {
  yield takeEvery(actionTypes.changePassword.SUBMIT, submitChangePassword)
}
